<template>
	<div style="margin-top: -20px;">
		<el-row>
			<el-col :span="9">
				<span style="font-weight: 600;color: #000;font-size: 15px;">
					订单状态：{{ orderstatename }}
				</span>
				<span style="margin-left: 40px;">
					<a style="color: #4D72DD;cursor:pointer;" @click="printPaper">补打出餐条</a>
				</span>
				<p v-if="'notpay' == orderInfo[0].Stallsorders_State">
					<span style="float: left;">买家({{orderInfo[0].Stallsorders_Orderwechatname}})需在 </span>
					<el-statistic style="width: 90px;float: left;margin-top: 4px;" :value-style="{fontSize: '14px',color:'#FCC97D'}" @finish="countDwonFinish" format="mm分:ss秒" :value="deadline3" time-indices title="" >
						<template slot="prefix">
							<i style="color: #FCC97D;" class="el-icon-time"></i>
						</template>
					</el-statistic>
					<span>内付款；若未及时付款，系统将自动取消订单。</span>
				</p>
			</el-col>
			<el-col :span="15">
				<div style="margin-top: 0px;margin-left: 20px;">
					<el-steps process-status="finish" finish-status="success" :active="timecurrent" align-center>
						<el-step v-for="(item, index) in timelineData" :key="index" :title="item.timestamp" 
							:description="item.time"></el-step>
					</el-steps>
					<!-- <el-timeline :reverse="false">
					    <el-timeline-item style="width: 25%;" size="large" placement="top" v-for="(item, index) in timelineData" :key="index" :timestamp="item.timestamp">
							<template slot="dot">
								<span style="width: 32px;height: 32px;line-height: 32px;text-align: center;background-color: #4D72DD;
									border-radius: 50%;color: #fff;font-size: 16px;">
									{{index+1}}
								</span>
							</template>
							{{item.time}}
					    </el-timeline-item>
					</el-timeline> -->
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 0px;margin-left: 20px;" v-show="overinfoshow">
			<el-row>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						结束订单操作人：{{ orderlog_createuser }}
					</span>
				</el-col>
				<el-col :span="7">
					<span style="color: #000;font-size: 15px;">
						变更内容：{{ orderlog_context }}
					</span>
				</el-col>
				<el-col :span="10">
					<span style="color: #000;font-size: 15px;">
						备注：{{ orderlog_detail }}
					</span>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;">
			<p ><i style="color: #4D72DD;" class="el-icon-caret-right"></i> 基本信息</p>
			<el-row>
				<el-col :span="6">
					<div style="background-color: #fafafa;padding: 20px;margin-right: 10px;">
						<p style="font-size: 15px;font-weight: 600;color: #000;margin-top: 0px;">交易信息</p>
						<p>订单编号：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Orderno}}</span></p>
						<p>订餐类型：<span style="color: #000;">{{orderInfo[0].FoodCategory}}</span></p>
						<p>下单时间：<span style="color: #000;">{{orderInfo[0].Stallsorders_Ordertime.replace('T',' ') }}</span></p>
						<p>付款时间：<span style="color: #000;"> </span></p>
						<p>取消时间：<span style="color: #000;">{{time_cancel.replace('T',' ') }}</span></p>
					</div>
				</el-col>
				<el-col :span="6">
					<div style="background-color: #fafafa;padding: 20px;margin-right: 10px;">
						<p style="font-size: 15px;font-weight: 600;color: #000;margin-top: 0px;">客户信息</p>
						<p>客户昵称：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Orderwechatname}}</span></p>
						<p>客户电话：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Telphone}}</span></p>
						<p>收 餐 人：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Recipient }}</span></p>
						<p>收餐电话：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Recipientphone }}</span></p>
					</div>
					
				</el-col>
				<el-col :span="6">
					<div style="background-color: #fafafa;padding: 20px;margin-right: 10px;">
						<p style="font-size: 15px;font-weight: 600;color: #000;margin-top: 0px;">商家信息</p>
						<div v-for="(stall,index) in orderInfo" :key="stall.Stallsorders_Orderno + stall.Stallsorders_Subno+index">
							<p>档口名称：<span style="color: #000;">{{ stall.Stalls_Name }}</span></p>
							<p>联系电话：<span style="color: #000;">{{ stall.Stalls_Contactname +' '+ stall.Stalls_Telphone }}</span></p>
							<p>订单序号：<span style="color: #000;">{{ stall.Stallsorders_Serialnumber }}</span></p>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div style="background-color: #fafafa;padding: 20px;">
						<p style="font-size: 15px;font-weight: 600;color: #000;margin-top: 0px;">配送信息</p>
						<p>配送地址：<span style="color: #000;">{{ (orderInfo[0].Stallsorders_Sendarea ? orderInfo[0].Stallsorders_Sendarea : '') + orderInfo[0].Stallsorders_Sendaddress}}</span></p>
						<p>预订送达：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Pickupperiod }}</span></p>
						<p>订单备注：<span style="color: #000;">{{ orderInfo[0].Stallsorders_Remark }}</span></p>
						<p>配送人员：<span style="color: #000;">{{  orderInfo[0].Deliveryperson_Realname }}</span></p>
						<p>配送人电话：<span style="color: #000;">{{ orderInfo[0].Deliveryperson_Telphone }}</span></p>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;">
			<p ><i style="color: #4D72DD;" class="el-icon-caret-right"></i> 商品信息</p>
			<el-table :data="foodsList" :span-method="listSpanMethod" style="width: 100%" >
				<el-table-column prop="name" label="菜品" width="260" align="center">
					<template slot-scope="scope">
						<el-row style="margin-top: 0px;">
							<el-col :span="24" >
								<div style="width: 100px;float: left;">
									<el-image style="width: 60px; height: 60px;border-radius: 10px;" :src="scope.row.picurl"  fit="cover"></el-image>
								</div>
								<div style="text-align: left;">
									<p style="color: #409EFF;font-size: 12px;margin-top: 0px;margin-bottom: 0px;">{{scope.row.name}}</p>
									<p style="font-size: 12px;margin-top: 0px;">规格：{{scope.row.spec}}</p>
								</div>
							</el-col>
						</el-row>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="businessname" label="商家" align="center"></el-table-column> -->
				<el-table-column prop="stallname" label="档口" align="center"></el-table-column>
				<el-table-column prop="price" label="单价" width="100" align="center">
					<template slot-scope="scope">
						￥{{scope.row.price}}
					</template>
				</el-table-column>
				<el-table-column prop="packprice" label="打包费" width="100" align="center">
					<template slot-scope="scope">
						￥{{scope.row.packprice}}
					</template>
				</el-table-column>
				<el-table-column prop="number" label="购买数量" width="100" align="center">
					<template slot-scope="scope">
						x{{scope.row.number}}
					</template>
				</el-table-column>
				<el-table-column prop="deliverfee" label="配送费" align="center">
					<!-- <template slot-scope="scope">
						￥{{scope.row.deliverfee}}
					</template> -->
				</el-table-column>
				<!-- <el-table-column prop="coupons" label="优惠劵" align="center">
					<template slot-scope="scope">
						<p v-show="couponsInfo.category == 'platform' || (couponsInfo.category == 'business' && couponsInfo.stallid==scope.row.stallid)">
							<el-tag v-if="couponsInfo.type == 'cash'">{{couponsInfo.typename}}</el-tag>
							<el-tag v-if="couponsInfo.type == 'discount'" type="success">{{couponsInfo.typename}}</el-tag>
							<el-tag v-if="couponsInfo.type == 'fullreduction'" type="warning">{{couponsInfo.typename}}</el-tag>
						</p>
						<p style="color: #000;" v-show="couponsInfo.category == 'platform' || (couponsInfo.category == 'business' && couponsInfo.stallid==scope.row.stallid)"> 
							<span style="color: #909399;font-size: 12px;">{{couponsInfo.category == 'platform' ? '平台' : '商家'}}</span>
							{{couponsInfo.content}}
						</p>
					</template>
				</el-table-column> -->
			</el-table>
			<div style="border-bottom: #e1e1e1 solid 1px;text-align: right;padding-right: 60px;">
				<!-- <p  v-show="couponsInfo.category == 'platform' || couponsInfo.category == 'business'">
					<el-tag v-if="couponsInfo.type == 'cash'">{{couponsInfo.typename}}</el-tag>
					<el-tag v-if="couponsInfo.type == 'discount'" type="success">{{couponsInfo.typename}}</el-tag>
					<el-tag v-if="couponsInfo.type == 'fullreduction'" type="warning">{{couponsInfo.typename}}</el-tag>
				</p> -->
				<p style="color: #000;" v-show="couponsInfo.category == 'platform' || couponsInfo.category == 'business'"> 
					{{couponsInfo.category == 'platform' ? '' : couponsInfo.stallname}}
					<span style="color: #909399;font-size: 12px;">已用</span>
					{{couponsInfo.category == 'platform' ? '平台' : '商家'}}{{couponsInfo.typename}} {{couponsInfo.content}}
				</p>
			</div>
			<div style="border-bottom: #e1e1e1 solid 1px;text-align: right;padding-right: 60px;">
				<p>菜品总价：<span style="font-weight: 600;color: #000;">￥{{foods_total_Undiscountamount}}</span></p>
				<p>打 包 费：<span style="font-weight: 600;color: #000;">+￥{{foods_Packprice}}</span></p>
				<!-- <p>配 送 费：<span style="font-weight: 600;color: #000;">+￥{{orderInfo[0].Stallsorders_Deliverfee}}</span></p> -->
				<p>优惠金额：<span style="font-weight: 600;color: #000;">-￥{{foods_total_Discountamount}}</span></p>
				<p>应收金额：<span style="font-weight: 600;color: #409EFF;">￥{{foods_total_Amount}}</span></p>
			</div>
		</div>
		
	</div>
</template>

<script>
	import { Decimal } from 'decimal.js'
	import { baseUrl,nfsprefix } from '/static/baseUrl.js'
	import { queryOrderDetail,queryOrderTimeline,reprintOrderPaper } from '/static/apiUrl.js'
	export default {
		name : 'OrderDetail',
		data() {
			return {
				deadline3: 0,
				orderInfo :[],
				timelineData: [
					{ timestamp: '顾客下单', state: 'notpay' ,time:'' },
					{ timestamp: '顾客付款', state: 'notdining',time:'' },
					{ timestamp: '菜品配送', state: 'sending',time:'' },
					{ timestamp: '菜品送达', state: 'sended',time:'' },
					{ timestamp: '订单结束', state: 'overed',time:'' }
				],
				time_cancel: '',
				foods_total_Undiscountamount: 0,
				foods_total_Discountamount: 0,
				foods_total_Amount: 0,
				foods_Packprice: 0,
				timecurrent : 0,
				foodsList : [],
				orderstatename : '',
				couponsInfo : {
					id : '',
					code : '',
					category : '',
					type : '',
					typename : '',
					content : '',
					dikouamount : 0,
					discount : 0,
					full : 0,
					mins : 0
				},
				orderlog_context : '',
				orderlog_detail : '',
				orderlog_createuser: '',
				overinfoshow: false,
			}
		},
		props: {
			orderno : {
				type: String,
				required: false
			},
			
		},
		watch: {
			orderno: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.orderInfo = []
					this.foodsList = []
					this.overinfoshow = false
					this.initData()
				}
			},
		},
		mounted() {
			//this.initData()
		},
		methods: {
			initData(){
				queryOrderDetail({
					userId : '',
					orderNum : this.orderno
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.orderInfo = res.data
						if( 'notpay' == res.data[0].Stallsorders_State){
							this.timecurrent = 0
							this.orderstatename = '等待顾客付款'
						}else if('notdining' == res.data[0].Stallsorders_State){
							this.timecurrent = 1
							this.orderstatename = '顾客已付款，等待出餐'
						}else if('notsend' == res.data[0].Stallsorders_State){
							this.timecurrent = 1
							this.orderstatename = '已出餐，等待配送'
						}else if('sending' == res.data[0].Stallsorders_State){
							this.timecurrent = 2
							this.orderstatename = '配送中'
						}else if('sended' == res.data[0].Stallsorders_State){
							this.timecurrent = 3
							this.orderstatename = '已送达，等待顾客取餐'
						}else if('pickuped' == res.data[0].Stallsorders_State){
							this.timecurrent = 3
							this.orderstatename = '顾客已取餐'
						}else if('overed' == res.data[0].Stallsorders_State){
							this.timecurrent = 4
							this.orderstatename = '订单已结束'
							this.orderlog_context = res.data[0].Orderlogs_Context
							this.orderlog_detail = res.data[0].Orderlogs_Detail
							this.orderlog_createuser = res.data[0].Orderlogs_createuser							
							this.overinfoshow = true
						}else if('cancel' == res.data[0].Stallsorders_State){
							this.timecurrent = 4
							this.orderstatename = '顾客已取消'
							this.orderlog_context = res.data[0].Orderlogs_Context
							this.orderlog_detail = res.data[0].Orderlogs_Detail
							this.orderlog_createuser = res.data[0].Orderlogs_createuser							
							this.overinfoshow = true
						}

						//使用优惠券
						if(res.data[0].Coupons_Id){
							let tyname = '';
							let ctmp = '';
							let full = new Decimal('0')
							let mins = new Decimal('0') 
							if(res.data[0].Coupons_Fullreduction != null && res.data[0].Coupons_Fullreduction != ''){
								try{
									let temp = res.data[0].Coupons_Fullreduction.split('-')
									full = new Decimal(temp[0])
									mins = new Decimal(temp[1])
								}catch(e){
									//TODO handle the exception
								}
							}
							if('cash' == res.data[0].Coupons_Type){
								tyname = '现金券'
								ctmp = '抵扣'+res.data[0].Coupons_Deductionamount+'元'
							}else if('discount' == res.data[0].Coupons_Type){
								tyname = '折扣券'
								ctmp = '打'+res.data[0].Coupons_Discountratio+'折'
							}else if('fullreduction' == res.data[0].Coupons_Type){
								tyname = '满减券'
								ctmp = '满'+full+'减'+mins
							}
							this.isusedCoupon = true
							//订单使用的优惠券
							this.couponsInfo.category = res.data[0].Coupons_Category
							this.couponsInfo.code = res.data[0].Coupons_Code
							this.couponsInfo.id = res.data[0].Coupons_Id 
							this.couponsInfo.content = ctmp
							this.couponsInfo.type = res.data[0].Coupons_Type
							this.couponsInfo.typename = tyname
							this.couponsInfo.dikouamount = res.data[0].Coupons_Deductionamount
							this.couponsInfo.full = full
							this.couponsInfo.mins = mins
							this.couponsInfo.discount = res.data[0].Coupons_Discountratio
							this.couponsInfo.stallid = res.data[0].Coupons_Stallid
							this.couponsInfo.stallname = res.data[0].CouponStallName
						}
						
						let second = this.getSecondsBetweenDates(res.data[0].Stallsorders_Payendlinetime)
						this.deadline3 = Date.now() + (second > 0 ? (second * 1000) : 0)

						this.foods_total_Undiscountamount = new Decimal('0')
						this.foods_total_Discountamount = new Decimal('0')
						this.foods_total_Amount = new Decimal('0')
						this.foods_Packprice = new Decimal('0')
						res.data.forEach((item) => {
							this.foods_total_Undiscountamount = this.foods_total_Undiscountamount.add(new Decimal(item.Stallsorders_Undiscountamount))
							this.foods_total_Discountamount = this.foods_total_Discountamount.add(new Decimal(item.Stallsorders_Discountamount))
							this.foods_total_Amount = this.foods_total_Amount.add(new Decimal(item.Stallsorders_Totalamount))
							this.foods_Packprice = new Decimal(item.Stallsorders_Packprice)

							item.Orderfoods.forEach((food) => {
								let picurl = ''
								if(food.Foodspicture && food.Foodspicture.length> 0){
									picurl =  baseUrl + nfsprefix + food.Foodspicture[0].Foodspicture_Fileurl
								}
								this.foodsList.push({
									name : food.Orderfoods_Name,
									price : food.Orderfoods_Platformoffprice,
									number : food.Orderfoods_Unmber,
									spec : food.Orderfoods_Spec,
									packprice : food.Orderfoods_Packprice,
									id : food.Orderfoods_Orderid,
									deliverfee: '￥' + item.Stallsorders_Deliverfee,
									stallid : item.Stalls_Id,
									stallname : item.Stalls_Name,
									businessname : item.Stallsorders_Ownbusiness,
									picurl : picurl
								})
							})
						})
						this.foods_total_Undiscountamount -= this.foods_Packprice
					}
				})
				queryOrderTimeline({
					userId : '',
					orderno : this.orderno
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.timelineData[0].time = res.data.time_notpay
						this.timelineData[1].time = res.data.time_notdining ? res.data.time_notdining : ''
						this.timelineData[2].time = res.data.time_sending ? res.data.time_sending : ''
						this.timelineData[3].time = res.data.time_sended ? res.data.time_sended : ''
						this.timelineData[4].time = res.data.time_overed ? res.data.time_overed : (res.data.time_cancel ? res.data.time_cancel : '')
						this.time_cancel = res.data.time_cancel ? res.data.time_cancel : ''
					}
				})
			},
			countDwonFinish(){
				console.log("倒计时结束")
			},
			listSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log( row, column, rowIndex, columnIndex)
				/* if( columnIndex === 6 ){
					console.log("rows " ,row.length)
					if(rowIndex === 0){
						return [1,row.length]
					}else{
						return [0,0]
					}
				} */
			},
			getSecondsBetweenDates(times1, times2){
				const date1 = new Date(times1)
				const date2 = times2 == null ? new Date() : new Date(times2)
				const timestamp1 = date1.getTime(); // 转换为时间戳
				const timestamp2 = date2.getTime(); // 转换为时间戳
				// 计算两个日期时间戳之间的差值
				const differenceMs = timestamp1 - timestamp2;
				// 将差值转换为秒
				const seconds = Math.round(differenceMs / 1000);
				return seconds;
			},
			printPaper(){
				this.$prompt('请输入您的密码', '提示', {
					inputType: 'password',
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					//inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
					//inputErrorMessage: '邮箱格式不正确'
				}).then(({ value }) => {
					reprintOrderPaper({
						userId : '',
						orderid : this.orderInfo.Stallsorders_Id,
						pwd : this.$md5(value)
					}).then(res => {
						if(0 == res.code){
							this.$message({
								type: 'success',
								message: '打印成功'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
					
				}).catch(() => { });
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.el-timeline {
	  display: flex;
	  flex-direction: row;
	}
	 
	.el-timeline-item {
	  display: flex;
	  flex-direction: row;
	}
	 
	::v-deep .el-timeline-item__timestamp {
		display: block;
		order: 2;
	    color: #000;
		font-size: 15px;
	}
	 
	.el-timeline-item__node {
	  display: block;
	  order: 1;
	  flex-shrink: 0;
	  margin-right: 10px;
	}
	 
	::v-deep .el-timeline-item__content {
	  display: block;
	  order: 3;
	  margin-top: 50px;
	  color: #909399;
	}
	::v-deep .el-timeline-item__tail {
	  border-left: none;
	  border-top: 2px solid #e4e7ed;
	  width: 100%;
	  position: absolute;
	  top: 15px;
	}
	::v-deep .el-timeline-item__wrapper{
		top: -30px;
		margin-left: -10px;
	}
	
</style>